import * as React from 'react';
import { Linking, Pressable, StyleSheet, Text, View } from 'react-native';
import { translate } from 'secullum-i18n';
import { getTheme } from 'secullum-react-native-ui';
import { base64ToBlob } from '../../shared/modules/file';

interface Props {
  base64Imagem: string;
}

class VisualizadorImagem extends React.Component<Props> {
  render() {
    const { base64Imagem } = this.props;
    const prefixoJpeg = 'data:image/jpeg;base64,';

    const base64 = base64Imagem.startsWith(prefixoJpeg)
      ? base64Imagem.slice(prefixoJpeg.length)
      : base64Imagem;

    return (
      <View>
        <img src={prefixoJpeg + base64} style={{ width: '100%' }} />
        <View>
          <Pressable
            onPress={() => {
              const blob = base64ToBlob(base64, 'image/jpeg');
              const url = URL.createObjectURL(blob);

              Linking.openURL(url);
            }}
            style={({ pressed }) => [{ opacity: pressed ? 0.7 : 1 }]}
          >
            <Text
              nativeID="visualizador-imagem-download-arquivo"
              style={styles.link}
            >
              {translate('Download do Arquivo')}
            </Text>
          </Pressable>
        </View>
      </View>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  link: {
    paddingTop: 5,
    color: theme.textColor2
  }
});

export default VisualizadorImagem;
